import { CSSProperties, useCallback } from "react";
import { FloatingBackButton } from "../components/FloatingBackButton";
import { routes } from "../routes";
import { firebaseAuth } from "../firebase";
import { OAuthProvider, signInWithPopup } from "firebase/auth";
import { useNavigate } from "../utils";

interface Button {
  text: string;
  method: string;
  src?: string;
  alt?: string;
  buttonStyle?: CSSProperties;
  imgStyle?: CSSProperties;
  spanStyle?: CSSProperties;
}

const button = {
  ios: {
    src: "/images/apple.png",
    alt: "apple logo",
    text: "Apple로 계속하기",
    imgStyle: {
      filter: "invert(1)",
    },
    method: "apple.com",
    buttonStyle: {
      backgroundColor: "var(--gray-8)",
      borderColor: "var(--gray-8)",
    },
    spanStyle: {
      color: "white",
    },
  },
  google: {
    src: "/images/google.png",
    alt: "google logo",
    text: "Google로 계속하기",
    method: "google.com",
    buttonStyle: {
      backgroundColor: "var(--gray-2)",
    },
  },
  phone: {
    text: "휴대폰 번호로 계속하기",
    method: "phone",
  },
} as { [key: string]: Button };

const iosButtons = [button.ios, button.google, button.phone];
const androidButtons = [button.google, button.phone];

export const Login = () => {
  const navigate = useNavigate();
  const ios = window.location.pathname.includes(routes.ios);

  const login = useCallback(
    async (method: string) => {
      if (method === "phone") {
        navigate(routes.phoneNumberLogin);
        return;
      }
      if (method === "email") {
        navigate(routes.emailLogin);
        return;
      }
      try {
        const googleProvider = new OAuthProvider(method);
        googleProvider.addScope("email");
        const credential = await signInWithPopup(firebaseAuth, googleProvider);
        if (credential.user) {
          navigate(routes.result);
        }
      } catch {
        alert("다시 시도해주세요");
      }
    },
    [navigate]
  );

  return (
    <div className="landing">
      <FloatingBackButton />
      <header className="header">
        <img
          src="/images/logo.png"
          style={{ width: 180, height: 34 }}
          alt="orzo class logo"
        />
      </header>
      <div style={{ marginTop: 80 }} className="buttons">
        {(ios ? iosButtons : androidButtons).map((button) => (
          <button
            key={button.method}
            style={button.buttonStyle}
            onClick={() => login(button.method)}
          >
            {"src" in button && (
              <img
                src={button.src}
                style={{ width: 16, height: 16, ...button.imgStyle }}
                alt="apple logo"
              />
            )}
            <span style={{ fontSize: 16, marginLeft: 8, ...button.spanStyle }}>
              {button.text}
            </span>
          </button>
        ))}
        <span
          onClick={() => navigate(routes.emailLogin)}
          style={{ textAlign: "center" }}
        >
          이메일 회원 이신가요?{" "}
          <span style={{ textDecoration: "underline" }}>로그인</span>
        </span>
      </div>
    </div>
  );
};
